import { z } from "zod";

export const inviteUserRequestSchema = z.object({
  // .max() values match the DB columns so over-long input is a clean 400, never a Postgres-VARCHAR 500.
  email: z.email("Valid email is required").max(250, "Email too long"), // users.email VARCHAR(250)
  first_name: z.string().min(1, "First name is required").max(100, "Too long").regex(/\S/, "First name cannot be blank"), // users.first_name VARCHAR(100)
  last_name: z.string().min(1, "Last name is required").max(100, "Too long").regex(/\S/, "Last name cannot be blank"), // users.last_name VARCHAR(100)
  // "product:role" tokens (e.g. "passport:admin"); each segment bounded to user_roles VARCHAR(50). Array-of-strings
  // = proven codegen shape (cf. cortex suggestion_chips), matches the JWT claim format.
  roles: z.array(
    z
      .string()
      .regex(/^[^:]{1,50}:[^:]{1,50}$/, "Each role must be product:role (<=50 chars each)"),
  ),
});
